<main>
    <section class="form-wrapper">
        <section class="step">
            <form [formGroup]="form" class="form" style="padding-top: 6px;">
                <div class="section section--1">
                    <mat-form-field appearance="outline" class="Input Input--select Input--suffix"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Locación</mat-label>
                        <mat-select formControlName="hub">
                            @for (item of hubs; track item.id) {
                            <mat-option [value]="item.id">
                                {{ item.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="Input Input--select Input--suffix"
                        [class.Input--readonly]="form.disabled">
                        <mat-label>Unidad</mat-label>
                        <input type="text" matInput formControlName="plate" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="Input" [class.Input--readonly]="form.disabled">
                        <mat-label>VIN</mat-label>
                        <input type="text" matInput formControlName="vin" />
                    </mat-form-field>
                </div>

                <div class="section section--2">
                    <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
                            firstFormHasError('acountable', 'required') ||
                            firstFormHasError('acountable', 'pattern')
                        " [class.Input--readonly]="form.disabled">
                        <mat-label>Persona que realizará el servicio de
                            rebalanceo</mat-label>
                        <input type="text" matInput formControlName="acountable" />

                        @if (firstFormHasError('acountable', 'required')) {
                        <mat-error class="ErrorMessage">El responsable es obligatorio</mat-error>
                        } @if (firstFormHasError('acountable', 'pattern')) {
                        <mat-error class="ErrorMessage">
                            El nombre solo debe contener letras</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="section section--3">
                    <div>
                        <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
                                firstFormHasError('date', 'required')
                            " [class.Input--readonly]="form.disabled">
                            <mat-label>Fecha</mat-label>
                            <input matInput [matDatepicker]="date" readonly formControlName="date" />
                            <mat-datepicker-toggle matIconSuffix [for]="date"></mat-datepicker-toggle>
                            <mat-datepicker #date></mat-datepicker>

                            @if (firstFormHasError('date', 'required')) {
                            <mat-error class="ErrorMessage">Seleccione una fecha válida</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
                                firstFormHasError('hour', 'required')
                            " [class.Input--readonly]="form.disabled">
                            <mat-label>Hora</mat-label>
                            <input type="time" matInput formControlName="hour" />

                            @if (firstFormHasError('hour', 'required')) {
                            <mat-error class="ErrorMessage">Seleccione un horario válido</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
                                firstFormHasError('soc', 'required') ||
                                firstFormHasError('soc', 'min') ||
                                firstFormHasError('soc', 'max')" [class.Input--readonly]="form.disabled">
                            <mat-label>SOC%</mat-label>
                            <input type="number" matInput formControlName="soc" />

                            @if (firstFormHasError('soc', 'required')) {
                            <mat-error class="ErrorMessage">El SOC es obligatorio</mat-error>
                            } @if (firstFormHasError('soc', 'min')) {
                            <mat-error class="ErrorMessage">El SOC debe de ser mayor a 0</mat-error>
                            } @if (firstFormHasError('soc', 'max')) {
                            <mat-error class="ErrorMessage">El SOC debe de ser menor a 100</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="Input" [class.Input--errors]="
                                firstFormHasError('odo', 'required')
                            " [class.Input--readonly]="form.disabled">
                            <mat-label>Odómetro (km)</mat-label>
                            <input matInput formControlName="odo" mask="separator" suffix="km" thousandSeparator="."
                                [keepCharacterPositions]="true" />

                            @if (firstFormHasError('odo', 'required')) {
                            <mat-error class="ErrorMessage">El odómetro es obligatorio</mat-error>
                            } @if (firstFormHasError('odo', 'min')) {
                            <mat-error class="ErrorMessage">El odómetro tiene que ser mayor a 0</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    @if ((form.controls.odo.errors?.['mustConsentKmChange']
                    && !consentKmChangeCheckbox.value) ||
                    consentKmChangeCheckbox.value) {
                    <mat-card [appearance]="'outlined'" class="warning">
                        <mat-card-content>
                            El odómetro actual es: {{ formatKm(lastOdo!) }} Y
                            usted está cargando el kilometraje de servicio:
                            {{ form.controls.odo.value }}.
                            <div class="question">¿Desea continuar?</div>
                        </mat-card-content>

                        <mat-card-content>
                            <mat-checkbox [formControl]="consentKmChangeCheckbox" color="primary">
                                Sí, deseo continuar
                            </mat-checkbox>
                        </mat-card-content>
                    </mat-card>
                    }


                    <mat-form-field appearance="outline" class="Input Input--select Input--suffix"
                        [class.Input--errors]="
                                firstFormHasError('deviceId', 'required')
                            " [class.Input--readonly]="form.disabled">
                        <mat-label>Dispositivo</mat-label>
                        <mat-select formControlName="deviceId">
                            @for (deviceItem of deviceList; track $index) {
                            <mat-option [value]="deviceItem.id_rebalance_device">
                                {{ deviceItem.name }}
                            </mat-option>
                            }
                            @if(isLto(currentTenant())) {
                                <mat-option [value]='NULL_AS_STRING'>
                                    Sin Dispositivo
                                </mat-option>
                            }
                        </mat-select>

                        <app-icon-button buttonSize="normal" color="green" class="Input__suffix">
                            <app-icon appIcon iconSize="normal" [icon]="EIcons.expandMore" />
                        </app-icon-button>

                        @if (firstFormHasError('deviceId', 'required')) {
                        <mat-error class="ErrorMessage">Seleccione un dispositivo</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="Input Input--select Input--suffix"
                        [class.Input--errors]="
                                firstFormHasError('accesories', 'required')
                            " [class.Input--readonly]="form.disabled">
                        <mat-label>Accesorios</mat-label>
                        <mat-select color="primary" formControlName="accesories" multiple>
                            <mat-option value="Radio">Radio</mat-option>
                            <mat-option value="Luces">Luces</mat-option>
                            <mat-option value="Aire acondicionado">Aire acondicionado</mat-option>
                        </mat-select>

                        <app-icon-button buttonSize="normal" color="green" class="Input__suffix">
                            <app-icon appIcon iconSize="normal" [icon]="EIcons.expandMore" />
                        </app-icon-button>

                        @if (firstFormHasError('accesories', 'required')) {
                        <mat-error class="ErrorMessage">Seleccione al menos un accesorio</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="section section--5">
                    <div class="section__upload">
                        <app-button color="green" [hasIcon]="true" [isFull]="true"
                            (clicked)="rear_mobile_camera.click()">
                            Tomar foto
                            <app-icon appIcon [icon]="EIcons.photo_camera" iconSize="normal"
                                [iconMoveTopToBotton]="3" />
                        </app-button>

                        <input type="file" style="display: none" #rear_mobile_camera accept="image/*" capture="camera"
                            (change)="setFiles($event, files)" />

                        <app-button color="green" [hasIcon]="true" (clicked)="files.click()">
                            Subir foto
                            <app-icon appIcon [icon]="EIcons.publish" iconSize="normal" [iconMoveTopToBotton]="3" />
                        </app-button>

                        <input type="file" style="display: none" #files accept="image/*"
                            (change)="setFiles($event, files)" />
                    </div>

                    @if (previewImage()) {
                    <div class="section__preview">
                        <img [src]="previewImage()" alt="rebalancing preview" />
                    </div>
                    }
                </div>

                <footer>
                    <app-button [isFull]="true" (clicked)="save()" [isDisabled]="form.invalid">
                        Guardar
                    </app-button>
                </footer>
            </form>
        </section>
    </section>
</main>